import { useEffect, useMemo, useState } from 'react'

/*
  usePagination — corta una lista ya filtrada en páginas.

  Las tablas del ERP crecen sin techo (caja, facturas, pagos) y renderizarlas
  enteras vuelve lento el scroll y hace ilegible la vista. Este hook es la
  fuente única del corte: la página se clampa sola si la lista se achica
  (borraste la última fila de la página 7) y vuelve a 1 cuando cambian los
  filtros — para eso está `resetKey`, que debe ser la firma de los filtros.
*/
export function usePagination<T>(items: T[], pageSize = 15, resetKey?: string) {
  const [page, setPage] = useState(1)

  useEffect(() => { setPage(1) }, [resetKey])

  const totalPages = Math.max(1, Math.ceil(items.length / pageSize))
  const current = Math.min(page, totalPages)

  const paginated = useMemo(
    () => items.slice((current - 1) * pageSize, current * pageSize),
    [items, current, pageSize],
  )

  return { page: current, setPage, totalPages, paginated, pageSize, total: items.length }
}
